import { createFileRoute } from '@tanstack/react-router'
import Distribution from 'Edition/components/sections/General/Distribution/Distribution'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/distribution')({
    component: Distribution,
})
